import React from 'react';
import {
  signupV1,
  signupV2,
  signupCountries,
  signupCountryStates,
} from './snippets';
import {
  Introduction,
  SignupV1,
  SignupV2,
  SignupCountries,
  SignupCountryState,
} from '../../../components';

const apiList = [
  {
    listItem: 'Introduction',
    content: <Introduction />,
  },
  {
    listItem: 'Sign Up',
    list: [
      {
        listItem: 'Sign Up V1',
        content: <SignupV1 />,
        snippet: [
          {
            language: 'javascript',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'javascript',
                  text: signupV1.request.javascript[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupV1.response.success[0],
                },
              },
              {
                title: 'Error Response:',
                code: {
                  language: 'json',
                  text: signupV1.response.error,
                },
              },
            ],
          },
          {
            language: 'shell',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'bash',
                  text: signupV1.request.shell[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupV1.response.success[0],
                },
              },
              {
                title: 'Error Response:',
                code: {
                  language: 'json',
                  text: signupV1.response.error,
                },
              },
            ],
          },
          {
            language: 'ruby',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'ruby',
                  text: signupV1.request.ruby[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupV1.response.success[0],
                },
              },
              {
                title: 'Error Response:',
                code: {
                  language: 'json',
                  text: signupV1.response.error,
                },
              },
            ],
          },
          {
            language: 'python',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'python',
                  text: signupV1.request.python[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupV1.response.success[0],
                },
              },
              {
                title: 'Error Response:',
                code: {
                  language: 'json',
                  text: signupV1.response.error,
                },
              },
            ],
          },
        ],
      },
      {
        listItem: 'Sign Up Countries',
        content: <SignupCountries />,
        snippet: [
          {
            language: 'javascript',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'javascript',
                  text: signupCountries.request.javascript[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountries.response.success[0],
                },
              },
              {
                title: 'Example Code:',
                code: {
                  language: 'javascript',
                  text: signupCountries.request.javascript[1],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountries.response.success[1],
                },
              },
            ],
          },
          {
            language: 'shell',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'bash',
                  text: signupCountries.request.shell[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountries.response.success[0],
                },
              },
              {
                title: 'Example Code:',
                code: {
                  language: 'bash',
                  text: signupCountries.request.shell[1],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountries.response.success[1],
                },
              },
            ],
          },
          {
            language: 'ruby',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'ruby',
                  text: signupCountries.request.ruby[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountries.response.success[0],
                },
              },
              {
                title: 'Example Code:',
                code: {
                  language: 'ruby',
                  text: signupCountries.request.ruby[1],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountries.response.success[1],
                },
              },
            ],
          },
          {
            language: 'python',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'python',
                  text: signupCountries.request.python[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountries.response.success[0],
                },
              },
              {
                title: 'Example Code:',
                code: {
                  language: 'python',
                  text: signupCountries.request.python[1],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountries.response.success[1],
                },
              },
            ],
          },
        ],
      },
      {
        listItem: 'Sign Up Country State',
        content: <SignupCountryState />,
        snippet: [
          {
            language: 'javascript',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'javascript',
                  text: signupCountryStates.request.javascript[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountryStates.response.success[0],
                },
              },
            ],
          },
          {
            language: 'shell',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'bash',
                  text: signupCountryStates.request.shell[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountryStates.response.success[0],
                },
              },
            ],
          },
          {
            language: 'ruby',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'ruby',
                  text: signupCountryStates.request.ruby[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountryStates.response.success[0],
                },
              },
            ],
          },
          {
            language: 'python',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'python',
                  text: signupCountryStates.request.python[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupCountryStates.response.success[0],
                },
              },
            ],
          },
        ],
      },
      {
        listItem: 'Sign Up V2',
        content: <SignupV2 />,
        snippet: [
          {
            language: 'javascript',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'javascript',
                  text: signupV2.request.javascript[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupV2.response.success[0],
                },
              },
              {
                title: 'Error Response:',
                code: {
                  language: 'json',
                  text: signupV2.response.error,
                },
              },
            ],
          },
          {
            language: 'shell',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'bash',
                  text: signupV2.request.shell[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupV2.response.success[0],
                },
              },
              {
                title: 'Error Response:',
                code: {
                  language: 'json',
                  text: signupV2.response.error,
                },
              },
            ],
          },
          {
            language: 'ruby',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'ruby',
                  text: signupV2.request.ruby[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupV2.response.success[0],
                },
              },
              {
                title: 'Error Response:',
                code: {
                  language: 'json',
                  text: signupV2.response.error,
                },
              },
            ],
          },
          {
            language: 'python',
            body: [
              {
                title: 'Example Code',
                code: {
                  language: 'python',
                  text: signupV2.request.python[0],
                },
              },
              {
                title: 'Success Response:',
                code: {
                  language: 'json',
                  text: signupV2.response.success[0],
                },
              },
              {
                title: 'Error Response:',
                code: {
                  language: 'json',
                  text: signupV2.response.error,
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    listItem: 'Login',
    list: [{ listItem: 'Login V1' }],
  },
  {
    listItem: 'Create User',
    list: [{ listItem: 'Create User V1' }],
  },
  {
    listItem: 'Membership',
    list: [{ listItem: 'Subscribe' }],
  },
  {
    listItem: 'KYC',
    list: [{ listItem: 'Status' }],
  },
  {
    listItem: 'Crypto',
    list: [
      { listItem: 'Available Currencies' },
      { listItem: 'Deposit Quote' },
      { listItem: 'Create Deposit' },
      { listItem: 'Deposit' },
      { listItem: 'Cancel Deposit' },
      { listItem: 'Crypto Member Wallet' },
      { listItem: 'Crypto Transaction' },
    ],
  },
  {
    listItem: 'eWallet',
    list: [
      { listItem: 'Get Wallet List' },
      { listItem: 'Transaction M2M' },
      { listItem: 'Payment Request' },
    ],
  },
  {
    listItem: 'Error',
  },
];

export { apiList };
